// 账单状态 SYS_BMS_BILL_STATUS
export const BILLSTATUS = {
    TO_BECON_FIRMED: 30, // 待确认
    CONFIRM: 31, // 已确认待盖章
    COST_DIFFERENCE: 32, // 费用差异
    SEAL_CONFIRMATION: 40, // 盖章确认
    INVOICE_SENT: 60, // 发票寄出
    INVOICE_WITHDRAWAL: 90, // 发票撤回
    RECEIPT_OF_INVOICE: 70, // 发票签收
    INVOICE_RETURN: 80 // 发票退回
};

// 供应商押金状态  SRM_BMS_SUP_DEPOSIT_STATUS
export const DEPOSITSTATUS = {
    NEWLY_BUILD: 10, // 新建
    CONFIRM: 20, // 确认
    PARTIAL_PAYMENT: 30, // 部分付款
    FULL_PAYMENT: 40, // 全部付款
    PARTIAL_REFUND: 50, // 部分退还
    REFUND_ALL: 60, // 全部退还
    DISCARD: 90 // 废弃
};

// 供应商押金类型  SRM_BMS_SUP_DEPOSIT_TYPE
export const SUPDEPOSITTYPE = {
    OPERATDE_POSIT: 1, // 运作押金
    PREMIUM: 2, // 质保金
    BID_SECURITY: 3, // 投标保证金
    OIL_CARD_DEPOSIT: 4 // 油卡押金
};

// SYS_BMS_DEPOSIT_AP_STATUS
export const BMSDEPOSITAPSTATUS = {
    TO_BE_SUBMITTED: 10, // 待提交
    TO_BE_AUDITED: 20, // 待审核
    OPERATION_REVIEWED: 21, // 运作已审核
    FINANCIAL_REVIEWED: 22, // 财务已审核
    AUDIT_PASS: 30, // 审核通过
    AUDIT_FAILED: 40, // 审核不通过
    TO_VOID: 99 // 作废
};

// 合同状态
export const CONTRACT_STATUS = {
    NEWLY_ADDED: '新增',
    TAKE_EFFECT: '生效',
    TO_BE_AUDITED: '待审核',
    AUDIT_REJECTED: '审核驳回',
    SUSPENSION: '中止',
    TERMINATION: '终止',
    DISCARD: '废弃'
};

// 费用核对状态 SYS_BMS_TASK_STATUS
export const COST_BMS_TASK_STATUS = {
    TO_BECON_FIRMED: '30', // 待确认
    COST_CONSISTENT: '40', // 费用一致
    COST_DIFFERENCE: '41', // 费用差异
    TASK_CONFIRMATION: '50' // 任务确认
};

// 任务类型 SRM_BMS_TASK_TYPE
export const BMS_TASK_TYPE = {
    BILLING_DATA_TASK: '10', // 计费数据任务
    ESTIMATED_DATA_TASK: '20' // 预估数据任务
};

// 业务类型  BID_BUSINESS_TYPE
export const BUSINESS_TYPE = {
    WAREHOUSING: '1', // 仓储
    LOADING_AND_UNLOADING: '2', // 装卸
    TRANSPORT: '3', // 运输
    DELIVERY: '4', // 配送
    EXPRESS_DELIVERY: '5', // 快递
    OTHER_BUSINESS: '6', // 其他业务
    ASSET_RESALE: '7', // 资产转卖
    HOME_DELIVERY: '10', // 宅配
    INSTALL: '12' // 安装
};

export const PRINT_IF = {
    ZERO: 0,
    ONE: 1
};

// 限制文件大小
export const FILE_SIZE = {
    TEN: 10,
    FIVE_HUNDRED: 500,
    ONE_THOUSAND_AND_TWENTY_FOUR: 1024
};

// 校验规则
export const CHECK = {
    TEN_THOUSAND: 10000,
    TWO: 2
};

// 定时器
export const TIMER = {
    THREE_HUNDRED: 300,
    FIVE_THOUSAND: 5000,
    FIVE_HUNDRED: 500
};

// 自定义
export const CUSTOM = {
    TWO: 2,
    NINE_HUNDRED_AND_NINETY_NINE: 999
};

// 缴纳方式  SYS_BMS_DEPOSIT_PAY_TYPE
export const DEPOSITPAYTYPE = {
    OFFLINE_PAYMENT: '线下打款',
    PAYMENT_OF_BEAUTY: '美的付',
    DEDUCTION_PAYABLE: '应付抵扣',
    DEPOSIT_ADJUSTMENT: '押金调账'
};

// 增值服务标识
export const INCREMENT_IDENT = {
    '0': '卸货不上楼', // 卸货不上楼
    '10': '卸货上楼', // 卸货上楼
    '20': '无增值服务' // 无增值服务
};

// 往来对账单对账单状态 SYS_DEALINGS_ACCOUNT_RESULT
export const DEALINGSACCOUNT = {
    NEW_CONSTRUCTION: 10, // 新建
    SENT_LETTER: 20, // 已发函
    SUPPLIER_CONFIRM_AGREE: 30, // 供方确认一致
    SUPPLIER_CONFIRM_DIFF: 40, // 供方确认差异
    DIFFERENCE_RECOVERED: 50, // 已回复差异
    STAMP_CONFIR: 60, // 盖章确认
    WITHDRAW: 70, // 撤回
    TERMINATION_RECONCILIATION: 80, // 终止对账
    UNDER_ARCHIVED: 90, // 归档中
    SUCESS_ARCHIVED: 91, // 归档成功
    FAIL_ARCHIVED: 92 // 归档失败
};